export const getStatusSelector = state => state.statuses.status;
export const getAllStatusesSelector = state => state.statuses.allStatuses;
export const statusesLoadingSelector = state => state.statuses.statusLoading;

